module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (194).70fbbf38.jpg";